import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface SocialnessBrowserModalProps {
  isOpen: boolean;
  onClose: () => void;
  url?: string;
}

export const SocialnessBrowserModal: React.FC<SocialnessBrowserModalProps> = ({ isOpen, onClose, url }) => {
  const { t } = useTranslation();
  const [failedEmbed, setFailedEmbed] = useState(false);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-hidden">
      <div className="flex min-h-screen items-center justify-center p-4 lg:ml-16">
        <div
          className="fixed inset-0 bg-black bg-opacity-25"
          onClick={onClose}
        />

        <div className="relative bg-white rounded-xl border border-black shadow-xl w-[95vw] lg:w-[calc(95vw-4rem)] max-w-none h-[95vh] overflow-hidden">
          <div className="flex items-center justify-between p-4 border-b border-gray-200">
            <div className="flex items-center gap-3">
              <h2 className="text-xl font-semibold">
                {t('socialness.browser', 'Socialness Browser')}
              </h2>
            </div>
            <div className="flex items-center gap-3">
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-500"
                title={t('common.close', 'Close')}
              >
                ×
              </button>
            </div>
          </div>

          <div className="flex-1 h-full">
            <div className="flex items-center justify-between px-4 py-2 border-b border-gray-200">
              <div className="text-sm text-gray-600 truncate" title={url}>{url || 'https://www.socialness.ai'}</div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => {
                    if (url) window.open(url, '_blank', 'noopener,noreferrer');
                  }}
                  className="text-sm text-primary-600 hover:text-primary-700"
                >
                  {t('common.openInNewTab', 'Open in new tab')}
                </button>
              </div>
            </div>
            <iframe
              src={url || 'https://www.socialness.ai'}
              className="w-full h-full min-h-[calc(95vh-80px)]"
              title="Socialness Browser"
              allow="clipboard-read; clipboard-write; fullscreen; autoplay; encrypted-media; picture-in-picture; web-share"
              sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-presentation allow-downloads allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation"
              onError={() => setFailedEmbed(true)}
              onLoad={() => setFailedEmbed(false)}
            />
            {failedEmbed && (
              <div className="absolute inset-0 bg-white/90 flex items-center justify-center">
                <div className="text-center">
                  <p className="text-gray-700 mb-3">{t('canva.embedBlocked', 'The editor refused to load in an embedded view.')}</p>
                  <button
                    onClick={() => { if (url) window.open(url, '_blank', 'noopener,noreferrer'); }}
                    className="inline-flex items-center px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700"
                  >
                    {t('actions.openInCanva', 'Open in Canva')}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};


